// import React, { useState } from "react";
// import { Button, Form } from "react-bootstrap";
// import { CardBody } from "reactstrap";
// import { DocumentLayoutJSON } from "../Json/OrderDetailsLayoutJSON";
// import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
// import { DocumentsFieldsJSON } from "../Json/OrderDetailsFieldsJSON";
// import { useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import {
//   downloadDocumentFile,
//   readData,
//   uploadDocuments,
// } from "../OrderService";
// import {
//   CrossIcon,
//   DownloadIcon,
//   EditListIcon,
// } from "../../../../assets/images/svg/svg";

// const CreateDocuments = () => {
//   const formState = useSelector((state) => state.common.formRendererState);
//   const files = useSelector(
//     (state) => state.order.selectedOrders.detailsData.files || {}
//   );
//   const detailsData = useSelector(
//     (state) => state.order.selectedOrders.detailsData
//   );
//   const { id } = useParams();
//   const editMode = !!id;

//   const [isEditing, setIsEditing] = useState({});
//   const [showUploadButton, setShowUploadButton] = useState(true);

//   const toggleEdit = (fieldKey) => {
//     setIsEditing((prevState) => ({
//       ...prevState,
//       [fieldKey]: !prevState[fieldKey],
//     }));
//     setShowUploadButton(true);
//   };

//   const findMatchingFileByFieldLabel = (fieldLabel) => {
//     return files[fieldLabel] || null;
//   };

//   const renderFileInput = (fieldKey) => {
//     const field = DocumentsFieldsJSON[fieldKey];
//     if (!field) {
//       console.error(`Field not found for key: ${fieldKey}`);
//       return null;
//     }

//     const file = findMatchingFileByFieldLabel(field["database-label"]);
//     if (file && !isEditing[fieldKey]) {
//       return (
//         <div className="document-wrapper">
//           <Form.Group>
//             <Form.Label className="document-label">
//               {field["display-fieldlabel"]}
//             </Form.Label>
//             <div className="d-flex justify-content-between align-items-center">
//               <p>{file.filename}</p>
//               <div className="documents-button-wrapper">
//                 <Button
//                   variant="outline-secondary"
//                   onClick={() =>
//                     downloadDocumentFile(file.entityid, file.filename)
//                   }
//                   className="me-2"
//                 >
//                   <DownloadIcon />
//                 </Button>
//                 <Button
//                   variant="outline-secondary"
//                   onClick={() => toggleEdit(fieldKey)}
//                 >
//                   <EditListIcon />
//                 </Button>
//               </div>
//             </div>
//           </Form.Group>
//         </div>
//       );
//     }
//     return (
//       <Form.Group className="documents">
//         <div className="d-flex align-items-center">
//           <div className="flex-grow-1">
//             {renderElement(field, DocumentsFieldsJSON, formState)}
//           </div>
//           {isEditing[fieldKey] && (
//             <span
//               className="cancel ms-2"
//               onClick={() => cancelEdit(fieldKey)}
//               style={{ cursor: "pointer" }}
//             >
//               <CrossIcon />
//             </span>
//           )}
//         </div>
//       </Form.Group>
//     );
//   };

//   const uploadOrderDocument = async () => {
//     try {
//       await uploadDocuments(
//         detailsData.entityid,
//         "ODR",
//         detailsData.entityid,
//         formState
//       );
//       await readData(id, "ODR");
//       setIsEditing({});
//       setShowUploadButton(true);
//     } catch (error) {
//       console.error("Error uploading document:", error);
//     }
//   };

//   const cancelEdit = (fieldKey) => {
//     setIsEditing((prevState) => ({
//       ...prevState,
//       [fieldKey]: false,
//     }));
//   };

//   const shouldEnableUploadButton = () => {
//     if (Object.keys(files).length === 0) return true;
//     return Object.keys(DocumentsFieldsJSON).some((key) => {
//       const file = findMatchingFileByFieldLabel(
//         DocumentsFieldsJSON[key]["database-label"]
//       );
//       const isEditingMode = isEditing[key];

//       return !file || isEditingMode;
//     });
//   };

//   return (
//     <div>
//       <Form>
//         <CardBody>
//           {DocumentLayoutJSON.map((element) => (
//             <div key={element.elementid}>
//               {element.child.map((child) => {
//                 const fieldKey = `${child.elementid}-${child.elementtype}`;
//                 return <div key={fieldKey}>{renderFileInput(fieldKey)}</div>;
//               })}
//             </div>
//           ))}
//         </CardBody>
//         {editMode && showUploadButton && (
//           <div className="d-flex justify-content-end mt-3">
//             <Button
//               type="button"
//               className="btn btn-secondary"
//               onClick={uploadOrderDocument}
//               disabled={!shouldEnableUploadButton()}
//             >
//               Upload
//             </Button>
//           </div>
//         )}
//       </Form>
//     </div>
//   );
// };

// export default CreateDocuments;


import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { DocumentLayoutJSON } from "../Json/OrderDetailsLayoutJSON";
import { DocumentsFieldsJSON } from "../Json/OrderDetailsFieldsJSON";
import { readData, uploadDocuments } from "../OrderService";
import DocumentUploader from "../../../../Components/Common/Documents/Documents";

const CreateDocuments = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const editMode = !!id;
  
  // Redux selectors
  const formState = useSelector((state) => state.common.formRendererState);
  const files = useSelector((state) => state.order.selectedOrders.detailsData.files || {});
  const detailsData = useSelector((state) => state.order.selectedOrders.detailsData);

  // Local state for editing
  const [isEditing, setIsEditing] = useState({});
  
  // Handle the document upload
  const handleUpload = async () => {
    try {
      await uploadDocuments(detailsData.entityid, "ODR", detailsData.entityid, formState);
      await dispatch(readData(id, "ODR"));
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };

  // Toggle editing for each document input
  const toggleEdit = (fieldKey) => {
    setIsEditing((prevState) => ({
      ...prevState,
      [fieldKey]: !prevState[fieldKey],
    }));
  };

  // Watch for changes in `files` data after `readData` to reset `isEditing`
  useEffect(() => {
    if (Object.keys(files).length > 0) {
      setIsEditing({});
    }
  }, [files]);

  return (
    <DocumentUploader
      documentLayout={DocumentLayoutJSON}
      documentFields={DocumentsFieldsJSON}
      files={files}
      formState={formState}
      onUpload={handleUpload}
      // onDownload={(entityid, filename) => downloadDocumentFile(entityid, filename)}
      entityid={detailsData.entityid}
      editMode={editMode}
      isEditing={isEditing}
      toggleEdit={toggleEdit}
      showUploadButtonByDefault={true}
    />
  );
};

export default CreateDocuments;
